import React from "react";
import { useLocation } from "react-router-dom";
import "./AdminSidebar.css";
import {
  FaClipboardList,
  FaCalendarCheck,
  FaUserFriends,
  FaFolderOpen,
} from "react-icons/fa";

const AdminSidebar = () => {
  const location = useLocation();

  return (
    <aside className="admin-sidebar">
      <nav>
        <a href="/admin/client-report" className={location.pathname === "/admin/client-report" ? "active" : ""}>
          <FaClipboardList className="icon" />
          <span>Client Report</span>
        </a>
        {/* Subscription removed */}
        <a href="/admin/appointments" className={location.pathname === "/admin/appointments" ? "active" : ""}>
          <FaCalendarCheck className="icon" />
          <span>Appointments</span>
        </a>
        <a href="/admin/patients" className={location.pathname === "/admin/patients" ? "active" : ""}>
          <FaUserFriends className="icon" />
          <span>Patients</span>
        </a>
        <a href="/admin/doctorview" className={location.pathname === "/admin/doctorview" ? "active" : ""}>
          <FaFolderOpen className="icon" />
          <span>Doctor View</span>
        </a>
      </nav>
    </aside>
  );
};

export default AdminSidebar;
